import { DSButton } from "@components/design-system/molecules";
import { DSNoteInput } from "@components/design-system/organisms/DSNoteInput";
import {
  faRedo,
  faFileExport,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useWatch } from "react-hook-form";

import { EditClientSummaryResult } from "./EditClientSummaryResult";

const GeneratedSummary = ({
  setStep,
  handleExportClientSummary,
  isClientSummaryEditable,
  control,
  isStreaming,
  noteUuid,
}) => {
  const clientSummary = useWatch({ control, name: "clientSummary" });

  const {
    aiAssistantEnabled,
    languageAiAssistantEnabled,
    subheadingsAiAssistantEnabled,
  } = useFlags();

  return (
    <>
      {isClientSummaryEditable ? (
        <EditClientSummaryResult
          control={control}
          noteUuid={noteUuid}
          aiAssistantEnabled={aiAssistantEnabled}
          languageAiAssistantEnabled={languageAiAssistantEnabled}
          subheadingsAiAssistantEnabled={
            subheadingsAiAssistantEnabled
          }
        />
      ) : (
        <DSNoteInput
          data={{ content: clientSummary || "" }}
          onChange={() => {}}
          disabled
          dataTestId="client-summary-streaming"
          showPlaceholderAlways={false}
        >
          <div className="relative">
            <DSNoteInput.NoteField
              section="freeform"
              showCopyButton={false}
              showSparkleButton={false}
            />
            {!clientSummary && (
              <div className="absolute inset-0 flex items-center justify-center">
                <FontAwesomeIcon
                  icon={faSpinner}
                  className="animate-spin text-2xl text-placeholder"
                />
                <span className="ml-sm text-placeholder">
                  Generating Client Summary...
                </span>
              </div>
            )}
          </div>
        </DSNoteInput>
      )}
      <div className="flex justify-center space-x-md my-6">
        <DSButton
          onClick={() => {
            setStep(1);
          }}
          disabled={!isClientSummaryEditable || isStreaming}
          variant="secondary"
        >
          <FontAwesomeIcon icon={faRedo} className="mr-2" />
          Restart Client Summary
        </DSButton>

        <DSButton
          onClick={handleExportClientSummary}
          disabled={!isClientSummaryEditable || isStreaming}
        >
          <FontAwesomeIcon icon={faFileExport} className="mr-2" />
          Export Client Summary
        </DSButton>
      </div>
    </>
  );
};

export default GeneratedSummary;
